<div class="breadcrumb-header justify-content-between">
  <div class="my-auto">
    <div class="d-flex">
      <h4 class="content-title mb-0 my-auto">Seguimiento blocks</h4>
      <span class="text-muted mt-1 tx-13 ms-2 mb-0">/ Panel de control</span>
    </div>
  </div>

  <div class="d-flex my-xl-auto right-content align-items-center gap-2">
    <button class="btn btn-light exit-btn" type="button" routerLink="/sistema/ordenes-fisicas-solicitudes">Salir</button>
  </div>
</div>

<div class="row row-sm">
  <div class="col-xl-12">
    <div class="card overflow-visible tracking-hero">
      <div class="card-body hero-body">
        <div class="hero-left">
          <p class="hero-kicker">{{ modoGlobal ? 'Búsqueda global' : 'Seguimiento operativo' }}</p>
          <h5 class="hero-title mb-0">{{ modoGlobal ? 'Resultados para "' + filtroSecuencia + '"' : 'Detalle de asignación activa' }}</h5>
          <p class="hero-subtitle mb-0">{{ modoGlobal ? blocksGlobales.length + ' block(s) encontrado(s)' : 'Rango ' + secuencia }}</p>
        </div>
        <div class="hero-right">
          <div class="metric-card">
            <span class="metric-label">N. blocks</span>
            <b class="metric-value">{{ modoGlobal ? blocksGlobales.length : numeroBlocks }}</b>
          </div>
          <div class="metric-card">
            <span class="metric-label">Precio 2D</span>
            <b class="metric-value">{{ modoGlobal ? '—' : (precio2D | currency:'USD':'symbol':'1.2-2') }}</b>
          </div>
          <div class="metric-card">
            <span class="metric-label">Disponibles</span>
            <b class="metric-value">{{ modoGlobal ? globalDisponibles : totalDisponibles }}</b>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="col-xl-12">
    <div class="card overflow-visible filter-card">
      <div class="card-body">
        <div class="filter-row">
          <input
            type="text"
            class="form-control filter-input"
            [(ngModel)]="filtroSecuencia"
            placeholder="Buscar por secuencia o block..."
            [disabled]="buscandoGlobal"
            (keyup.enter)="buscarGlobal()">
          <button class="btn btn-secondary" type="button" (click)="buscarGlobal()" [disabled]="buscandoGlobal">
            {{ buscandoGlobal ? 'Buscando...' : 'Buscar' }}
          </button>
          @if (modoGlobal) {
            <button class="btn btn-outline-secondary" type="button" (click)="limpiarBusquedaGlobal()">
              Volver
            </button>
          }
        </div>
        @if (modoGlobal) {
          <p class="text-muted small mb-0 mt-2">
            Mostrando resultados globales para <b>"{{ filtroSecuencia }}"</b> — {{ blocksGlobales.length }} block(s) encontrado(s).
          </p>
        }
      </div>
    </div>
  </div>

  <div class="col-xl-12">
    <div class="card overflow-visible table-card">
      <div class="card-body">
        @if (cargando || buscandoGlobal) {
          <div class="text-center">
            <div class="spinner-grow" role="status"></div>
            <p class="mt-2">{{ buscandoGlobal ? 'Buscando "' + filtroSecuencia + '"...' : 'Cargando blocks...' }}</p>
          </div>
        }

        @if (!cargando && !buscandoGlobal) {
          <div class="table-responsive d-none d-md-block">
            <table class="table table-bordered table-striped table-hover align-middle mb-0">
              <thead>
                <tr>
                  <th>Block</th>
                  <th>Asesor</th>
                  <th>Doctor</th>
                  <th>Estado</th>
                  <th>Días</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                @for (block of blocksFiltrados; track block; let i = $index) {
                  <tr [class.row-global-match]="modoGlobal && i === 0">
                    <td>
                      <span class="block-code">{{ block.NUMSIS_BLOCKS }}</span>
                    </td>
                    <td>
                      <span [class]="block.ASEASIG_BLOCK ? 'text-success fw-semibold' : 'text-danger fw-semibold'">
                        {{ block.ASEASIG_BLOCK || 'SIN ASIGNAR' }}
                      </span>
                    </td>
                    <td>
                      <span [class]="block.NOMDOC_BLOCK ? 'text-success fw-semibold' : 'text-danger fw-semibold'">
                        {{ block.NOMDOC_BLOCK || 'SIN ASIGNAR' }}
                      </span>
                    </td>
                    <td>
                      <span [class]="block.RESULTADO === 'DISPONIBLE' ? 'badge bg-success status-badge' : 'badge bg-warning status-badge'">
                        {{ block.RESULTADO }}
                      </span>
                    </td>
                    <td>{{ diasSinAsignacion(block) }}</td>
                    <td>
                      <div class="d-flex gap-1 flex-wrap action-wrap">
                        <button class="btn btn-secondary btn-sm" type="button" (click)="abrirAsignarAsesor(mdlAsignarAsesor, block)">
                          {{ block.ASEASIG_BLOCK ? 'Re asignar asesor' : 'Asignar asesor' }}
                        </button>
                        <button class="btn btn-secondary btn-sm" type="button" (click)="abrirAsignarDoctor(mdlAsignarDoctor, block)">
                          {{ block.NOMDOC_BLOCK ? 'Re asignar doctor' : 'Asignar doctor' }}
                        </button>
                        <button class="btn btn-outline-secondary btn-sm" type="button" (click)="abrirSecuencias(mdlSecuencias, block)">
                          Ver secuencias
                        </button>
                      </div>
                    </td>
                  </tr>
                }
                @if (blocksFiltrados.length === 0) {
                  <tr>
                    <td colspan="6" class="text-center text-muted">No hay blocks para este criterio.</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        }

        @if (!cargando && !buscandoGlobal) {
          <div class="mobile-list d-md-none">
            @for (block of blocksFiltrados; track block; let i = $index) {
              <article class="mobile-card" [class.row-global-match]="modoGlobal && i === 0">
                <div class="mobile-card__head">
                  <span class="block-code">{{ block.NUMSIS_BLOCKS }}</span>
                  <span [class]="block.RESULTADO === 'DISPONIBLE' ? 'badge bg-success status-badge' : 'badge bg-warning status-badge'">
                    {{ block.RESULTADO }}
                  </span>
                </div>
                <div class="mobile-card__meta">
                  <div>
                    <span>Asesor</span>
                    <b [class]="block.ASEASIG_BLOCK ? 'text-success' : 'text-danger'">
                      {{ block.ASEASIG_BLOCK || 'SIN ASIGNAR' }}
                    </b>
                  </div>
                  <div>
                    <span>Doctor</span>
                    <b [class]="block.NOMDOC_BLOCK ? 'text-success' : 'text-danger'">
                      {{ block.NOMDOC_BLOCK || 'SIN ASIGNAR' }}
                    </b>
                  </div>
                  <div>
                    <span>Días</span>
                    <b>{{ diasSinAsignacion(block) }}</b>
                  </div>
                </div>
                <div class="mobile-card__actions">
                  <button class="btn btn-secondary btn-sm" type="button" (click)="abrirAsignarAsesor(mdlAsignarAsesor, block)">
                    {{ block.ASEASIG_BLOCK ? 'Re asignar asesor' : 'Asignar asesor' }}
                  </button>
                  <button class="btn btn-secondary btn-sm" type="button" (click)="abrirAsignarDoctor(mdlAsignarDoctor, block)">
                    {{ block.NOMDOC_BLOCK ? 'Re asignar doctor' : 'Asignar doctor' }}
                  </button>
                  <button class="btn btn-outline-secondary btn-sm" type="button" (click)="abrirSecuencias(mdlSecuencias, block)">
                    Ver secuencias
                  </button>
                </div>
              </article>
            }
            @if (blocksFiltrados.length === 0) {
              <div class="mobile-empty text-center text-muted">
                No hay blocks para este criterio.
              </div>
            }
          </div>
        }
      </div>
    </div>
  </div>
</div>

<ng-template #mdlSecuencias let-modal>
  <div class="modal-header">
    <h6 class="modal-title">Secuencias del block {{ blockSeleccionado }}</h6>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="table-responsive d-none d-md-block">
      <table class="table table-striped table-bordered">
        <thead>
          <tr>
            <th>#</th>
            <th>Secuencia</th>
            <th>Doctor</th>
            <th>Paciente</th>
            <th>Fecha</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          @for (sec of secuenciasBlock; track sec; let i = $index) {
            <tr>
              <td>{{ i + 1 }}</td>
              <td>{{ sec.NUM_SECORD }}</td>
              <td>{{ sec.NOMDOC_SECORD || '-' }}</td>
              <td>{{ sec.CLI_SECORD || '-' }}</td>
              <td>{{ sec.FEC_SECORD ? (sec.FEC_SECORD | date:'dd/MM/yyyy') : '-' }}</td>
              <td>
                <button
                  class="btn btn-outline-secondary btn-sm"
                  type="button"
                  (click)="abrirAsignarDoctorSecuencia(mdlAsignarDoctorSecuencia, sec)">
                  {{ sec.NOMDOC_SECORD ? 'Cambiar doctor' : 'Asignar doctor' }}
                </button>
                @if (!tieneAsignacionSecuencia(sec)) {
                  <button
                    class="btn btn-outline-primary btn-sm ml-2"
                    type="button"
                    (click)="abrirAsignarOrdenSecuencia(mdlAsignarOrdenSecuencia, sec)">
                    Asignar orden
                  </button>
                }
              </td>
            </tr>
          }
          @if (secuenciasBlock.length === 0) {
            <tr>
              <td colspan="6" class="text-center text-muted">No hay secuencias registradas para este block.</td>
            </tr>
          }
        </tbody>
      </table>
    </div>

    <div class="mobile-list d-md-none">
      @for (sec of secuenciasBlock; track sec; let i = $index) {
        <article class="mobile-card">
          <div class="mobile-card__head">
            <span class="mobile-index">#{{ i + 1 }}</span>
            <span class="block-code">{{ sec.NUM_SECORD }}</span>
          </div>
          <div class="mobile-card__meta">
            <div><span>Doctor</span><b>{{ sec.NOMDOC_SECORD || '-' }}</b></div>
            <div><span>Paciente</span><b>{{ sec.CLI_SECORD || '-' }}</b></div>
            <div><span>Fecha</span><b>{{ sec.FEC_SECORD ? (sec.FEC_SECORD | date:'dd/MM/yyyy') : '-' }}</b></div>
          </div>
          <div class="mobile-card__actions">
            <button
              class="btn btn-outline-secondary btn-sm"
              type="button"
              (click)="abrirAsignarDoctorSecuencia(mdlAsignarDoctorSecuencia, sec)">
              {{ sec.NOMDOC_SECORD ? 'Cambiar doctor' : 'Asignar doctor' }}
            </button>
            @if (!tieneAsignacionSecuencia(sec)) {
              <button
                class="btn btn-outline-primary btn-sm"
                type="button"
                (click)="abrirAsignarOrdenSecuencia(mdlAsignarOrdenSecuencia, sec)">
                Asignar orden
              </button>
            }
          </div>
        </article>
      }

      @if (secuenciasBlock.length === 0) {
        <div class="mobile-empty text-center text-muted">
          No hay secuencias registradas para este block.
        </div>
      }
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-light" (click)="modal.dismiss('cancel')">Salir</button>
  </div>
</ng-template>

<ng-template #mdlAsignarDoctorSecuencia let-modal>
  <div class="modal-header">
    <h6 class="modal-title">Cambiar doctor de secuencia {{ secuenciaEdicion?.NUM_SECORD }}</h6>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="doctor-search">
      <input type="text" class="form-control" [(ngModel)]="doctorBusqueda" placeholder="Buscar por nombre, código, cédula o celular">
      <button class="btn btn-secondary" type="button" (click)="buscarDoctores()">Buscar</button>
    </div>

    <div class="table-responsive mt-3">
      <table class="table table-striped table-bordered">
        <thead>
          <tr>
            <th>#</th>
            <th>Código</th>
            <th>Doctor</th>
            <th>Celular</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          @for (doctor of doctores; track doctor; let i = $index) {
            <tr>
              <td>{{ i + 1 }}</td>
              <td>{{ doctor.CodVendedor }}</td>
              <td>{{ doctor.NombreVendedor }}</td>
              <td>{{ doctor.TelefonoMovil || '-' }}</td>
              <td>
                <button class="btn btn-secondary btn-sm" type="button" (click)="asignarDoctorSecuencia(doctor)" [disabled]="guardandoAsignacion">
                  {{ guardandoAsignacion ? 'Guardando...' : 'Seleccionar' }}
                </button>
              </td>
            </tr>
          }
          @if (doctores.length === 0) {
            <tr>
              <td colspan="5" class="text-center text-muted">Sin resultados. Usa el buscador para listar doctores.</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-light" (click)="modal.dismiss('cancel')">Salir</button>
  </div>
</ng-template>

<ng-template #mdlAsignarOrdenSecuencia let-modal>
  <div class="modal-header">
    <h6 class="modal-title">Asignar orden a secuencia {{ secuenciaEdicion?.NUM_SECORD }}</h6>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="order-search">
      <select class="form-control" [(ngModel)]="tipoBusquedaOrden">
        <option value="NOM_CLI">Paciente</option>
        <option value="NUM_ORD">N° Orden</option>
        <option value="numeroFacturaOrden">N° Factura</option>
      </select>
      <input type="text" class="form-control" [(ngModel)]="busquedaOrden" placeholder="Ejemplo: URETA / OE - GYE - 000123 / 581534">
      <button class="btn btn-secondary" type="button" (click)="buscarOrdenesParaSecuencia()" [disabled]="buscandoOrdenes">
        {{ buscandoOrdenes ? 'Buscando...' : 'Buscar' }}
      </button>
    </div>

    <div class="table-responsive mt-3">
      <table class="table table-striped table-bordered">
        <thead>
          <tr>
            <th>#</th>
            <th>N° Orden</th>
            <th>N° Factura</th>
            <th>Paciente</th>
            <th>Doctor</th>
            <th>Secuencia</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          @for (orden of ordenesBusqueda; track orden; let i = $index) {
            <tr>
              <td>{{ i + 1 }}</td>
              <td>{{ orden.NUM_ORD }}</td>
              <td>{{ orden.numeroFacturaOrden || '-' }}</td>
              <td>{{ orden.NOM_CLI }}</td>
              <td>{{ orden.NOM_DOC || '-' }}</td>
              <td>{{ orden.secuenciaOrden || '-' }}</td>
              <td>
                <button class="btn btn-secondary btn-sm" type="button" (click)="asignarOrdenASecuencia(orden)" [disabled]="guardandoAsignacion">
                  {{ guardandoAsignacion ? 'Guardando...' : 'Asignar orden' }}
                </button>
              </td>
            </tr>
          }
          @if (ordenesBusqueda.length === 0) {
            <tr>
              <td colspan="7" class="text-center text-muted">Sin resultados. Busca por paciente, número de orden o factura.</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-light" (click)="modal.dismiss('cancel')">Salir</button>
  </div>
</ng-template>

<ng-template #mdlAsignarAsesor let-modal>
  <div class="modal-header">
    <h6 class="modal-title">Seleccionar asesor para {{ bloqueEdicion?.NUMSIS_BLOCKS }}</h6>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="table-responsive">
      <table class="table table-striped table-bordered">
        <thead>
          <tr>
            <th>#</th>
            <th>Nombre</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          @for (asesor of asesores; track asesor; let i = $index) {
            <tr>
              <td>{{ i + 1 }}</td>
              <td>{{ asesor.nombre }}</td>
              <td>
                <button class="btn btn-secondary btn-sm" type="button" (click)="asignarAsesor(asesor)" [disabled]="guardandoAsignacion">
                  {{ guardandoAsignacion ? 'Guardando...' : 'Seleccionar' }}
                </button>
              </td>
            </tr>
          }
          @if (asesores.length === 0) {
            <tr>
              <td colspan="3" class="text-center text-muted">No hay asesores disponibles.</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-light" (click)="modal.dismiss('cancel')">Salir</button>
  </div>
</ng-template>

<ng-template #mdlAsignarDoctor let-modal>
  <div class="modal-header">
    <h6 class="modal-title">Asignar doctor para {{ bloqueEdicion?.NUMSIS_BLOCKS }}</h6>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="doctor-search">
      <input type="text" class="form-control" [(ngModel)]="doctorBusqueda" placeholder="Buscar por nombre, código, cédula o celular">
      <button class="btn btn-secondary" type="button" (click)="buscarDoctores()">Buscar</button>
    </div>

    <div class="table-responsive mt-3">
      <table class="table table-striped table-bordered">
        <thead>
          <tr>
            <th>#</th>
            <th>Código</th>
            <th>Doctor</th>
            <th>Celular</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          @for (doctor of doctores; track doctor; let i = $index) {
            <tr>
              <td>{{ i + 1 }}</td>
              <td>{{ doctor.CodVendedor }}</td>
              <td>{{ doctor.NombreVendedor }}</td>
              <td>{{ doctor.TelefonoMovil || '-' }}</td>
              <td>
                <button class="btn btn-secondary btn-sm" type="button" (click)="asignarDoctor(doctor)" [disabled]="guardandoAsignacion">
                  {{ guardandoAsignacion ? 'Guardando...' : 'Seleccionar' }}
                </button>
              </td>
            </tr>
          }
          @if (doctores.length === 0) {
            <tr>
              <td colspan="5" class="text-center text-muted">Sin resultados. Usa el buscador para listar doctores.</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-light" (click)="modal.dismiss('cancel')">Salir</button>
  </div>
</ng-template>
